<div class="toast-msg-conatiner" *ngIf="showToast">
    <div class="toast-msg" [style.backgroundColor]="isSuccess ? '#73d76a' : '#f54b4b'">
        {{notificationMsg}}
    </div>
</div>

<div *ngIf="isLoading" class="loading">
    <div class="spinner-border m-auto" role="status">
        <span class="sr-only ">Loading...</span>
    </div>
</div>

<div class="px-3 " style="background-color: white; min-height: 100%;">
    <div *ngIf="!isLoading" class="d-flex flex-column py-2">
        <div style=" position: sticky; top: 0; z-index: 100;">
            <!-- navigation -->
            <div class="all-container">
                <div class="row no-gutters nav-bar pt-1" style="background-color: #fff;">
                    <div (click)="changePage(1)" class="py-2 px-3">
                        <div class="pb-1" [ngStyle]="page==1 ? {'border-bottom':'2px outset #000'} : {'color':'#888888'}">
                            Accessories
                        </div>
                    </div>
                    <div (click)="changePage(2)" class="py-2 px-3">
                        <div class="pb-1" [ngStyle]="page==2 ? {'border-bottom':'2px outset #000'} : {'color':'#888888'}">
                            Service Product
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="page == 1" class="container-fluid p-0" [formGroup]="AccessoriesForm">
            <div class="row">
                <div class="col-12 p-0">

                    <div class="card p-4 mb-4">

                        <!-- Accessories Provided -->
                        <div formArrayName="accessoriesProvided">

                            <h5 class="mt-0 mb-3">Accessories Provided</h5>

                            <div *ngFor="let item of accessoriesProvidedArray.controls; let i = index"
                                [formGroupName]="i" class="form-row align-items-center mb-2">

                                <div class="col">
                                    <input type="text" class="form-control" formControlName="label"
                                        placeholder="Accessory name">
                                </div>

                                <div class="col-auto">
                                    <button type="button" class="btn btn-link text-danger p-0"
                                        (click)="removeAccessory(i)" title="Delete">
                                        <i class="bi bi-trash"></i>
                                    </button>
                                </div>

                            </div>

                            <button type="button" class="btn btn-outline-primary btn-sm mt-2"
                                style="color: #673AB7; border-color: #673AB7;" (click)="addProvidedAccessory()">
                                Add More
                            </button>

                        </div>


                        <!-- Accessories Missing -->
                        <div class="mt-4" formArrayName="accessoriesMissing">

                            <h5 class="mt-0 mb-3">Accessories Missing</h5>

                            <div *ngFor="let item of accessoriesMissingArray.controls; let i = index"
                                [formGroupName]="i" class="form-row align-items-center mb-2">

                                <div class="col">
                                    <input type="text" class="form-control" formControlName="label"
                                        placeholder="Accessory name">
                                </div>

                                <div class="col-auto">
                                    <button type="button" class="btn btn-link text-danger p-0"
                                        (click)="removeMissingAccessory(i)" title="Delete">
                                        <i class="bi bi-trash"></i>
                                    </button>
                                </div>

                            </div>

                            <button type="button" class="btn btn-outline-primary btn-sm mt-2"
                                style="color: #673AB7; border-color: #673AB7;" (click)="addMissingAccessory()">
                                Add More
                            </button>

                        </div>


                        <!-- Submit -->
                        <div class="mt-4 d-flex justify-content-end align-items-center">
                            <button type="button" class="btn btn-primary" [disabled]="hasEmptyAccessoryLabel()"
                                style="background-color: #673AB7; color: #fff; border: #673AB7;" (click)="submit()">
                                Submit
                            </button>
                        </div>

                    </div>

                </div>
            </div>
        </div>

        <div *ngIf="page == 2" class="container-fluid p-0">
            Coming Soon...
        </div>

    </div>
</div>